import './Template';
import './fancybox';

import '../scss/main.scss';
